import { Unit } from '../../../types'
import styles from './GridUnitsLayout.module.scss'
import Card from '../card/Card'
import DropBox from '../card/DropBox'
import CoverUnit from '@src/components/CoverUnit/CoverUnit'

type Props = {
    units: Unit[]
    source: string
    target?: string
    isAusCourse?: boolean
    handleDrop: (index: number, unit: Unit) => void
    handleLeftArrowAction?: (unit: Unit) => void
    handleRightArrowAction?: (unit: Unit) => void
    isNewMovable?: boolean  // New Cover moving state
}

function GridUnitsLayout(props: Props) {
    const { units, source, target, isAusCourse, isNewMovable, handleDrop, handleLeftArrowAction, handleRightArrowAction } = props

    const isAllUnits = source === "origin"

    let index = 0
    switch (source) {
        case 'grade':
            index = 1
            break
        case 'addition':
            index = 2
            break
        case 'origin':
            index = 0
            break
        default:
            index = 0
            break
    }

    return (
        <div className={isAllUnits ? styles.unitsDiv : styles.normalDiv }>
            {isAllUnits &&
                <DropBox
                    accept={"type"}
                    source={source}
                    onDrop={(item) => handleDrop(index, item)}
                />
            }
            {units.map((unit, index) => {
                if (isAusCourse) {
                    return (
                        <CoverUnit
                            key={index}
                            type={"type"}
                            source={source}
                            target={target}
                            unit={unit}
                            handleLeftArrowAction={() => handleLeftArrowAction && handleLeftArrowAction(unit)}
                            handleRightArrowAction={() => handleRightArrowAction && handleRightArrowAction(unit)}
                        />
                    )
                } else {
                    return (
                        <Card
                            key={index}
                            type={"type"}
                            source={source}
                            target={target}
                            unit={unit}
                            handleLeftArrowAction={() => handleLeftArrowAction && handleLeftArrowAction(unit)}
                            handleRightArrowAction={() => handleRightArrowAction && handleRightArrowAction(unit)}
                        />
                    )
                }
            }
            )}
            {!isAllUnits &&
                <DropBox
                    accept={"type"}
                    source={source}
                    onDrop={(item) => handleDrop(index, item)}
                    isAusCourse={isAusCourse}
                    isNewMovable={isNewMovable}
                />
            }
        </div>
    )
}

export default GridUnitsLayout